module.exports = __webpack_public_path__ + "static/media/linkedin.54471645.svg";